// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-menu-modal {
  z-index: 10;
  margin-top: 5px;
  position: absolute;
  top: 100%;
  left: 1px;
  right: 1px;
  display: grid;
  grid-template-columns: 1fr;
  background: #ebd9cd;
  outline: 2px solid #213555;
  border-radius: 10px;
  align-items: flex-start;
  padding: 4px;
  gap: 4px;
}
.app-menu-modal__item {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  border-radius: 10px;
  background: #f1e2d7;
  outline: 1px solid #D8C4B6;
  font-weight: 500;
}
.app-menu-modal__item--selected {
  background: #F5EFE7;
}
.app-menu-modal__item:hover {
  background: #fff9f2;
  outline: 1px solid #213555;
}`, "",{"version":3,"sources":["webpack://./src/components/AppSelectorMenu/AppMenuModal.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EAEA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,0BAAA;EAEA,mBCTY;EDUZ,0BAAA;EACA,mBAAA;EAEA,uBAAA;EACA,YAAA;EACA,QAAA;AALF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,2BAAA;EACA,mBAAA;EACA,aAAA;EAEA,mBAAA;EACA,mBC1BW;ED2BX,0BAAA;EACA,gBAAA;AAPJ;AASI;EACE,mBC7BS;ADsBf;AAUI;EACE,mBChCY;EDiCZ,0BAAA;AARN","sourcesContent":["@use \"../../utils/themeConstants\";\r\n\r\n.app-menu-modal {\r\n  z-index: 10;\r\n  margin-top: 5px;\r\n  position: absolute;\r\n  top: 100%;\r\n\r\n  left: 1px;\r\n  right: 1px;\r\n\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  \r\n  background: themeConstants.$color-light;\r\n  outline: 2px solid themeConstants.$color-dark;\r\n  border-radius: 10px;\r\n\r\n  align-items: flex-start;\r\n  padding: 4px;\r\n  gap: 4px;\r\n\r\n  &__item {\r\n    display: flex;\r\n    flex-direction: row;\r\n    width: 100%;\r\n  \r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    padding: 10px;\r\n  \r\n    border-radius: 10px;\r\n    background: themeConstants.$color-light1;\r\n    outline: 1px solid themeConstants.$color-medium;\r\n    font-weight: 500;\r\n\r\n    &--selected {\r\n      background: themeConstants.$color-bright;\r\n    }\r\n\r\n    &:hover {\r\n      background: themeConstants.$color-brightest;;\r\n      outline: 1px solid themeConstants.$color-dark;\r\n    }\r\n  }\r\n}","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
